import cn from 'classnames'

import './styles.scss'

interface LinkProps extends React.ComponentPropsWithoutRef<'a'> {
  prependIcon?: React.ReactNode
}

export const Link = ({ prependIcon = '', children, className, ...rest }: LinkProps) => (
  <a className={cn('link', className)} {...rest}>
    {prependIcon && <span className="link__prepend">{prependIcon}</span>}
    <span className="link__text">{children}</span>
  </a>
)
